import Tooltip from './Tooltip'
export { Tooltip }
export default Tooltip
